import { ReactNode } from 'react'
import styles from '../../styles/admin/SignIn.module.scss'
import SignInHeader from '../admin/SignInHeader'
import Greeting from '../common/Greeting'
import ContentBox from '../layout/ContentBox'
import SignInLayout from '../layout/SignInLayout'

type LayoutType = 'none' | 'standard' | 'secondary' | 'tertiary'

interface SignInPageProps {
  content: ReactNode
  layout?: LayoutType
  hasGreeting?: boolean
}

const LevelTestBox = ({ content, layout, hasGreeting }: SignInPageProps) => {
  return (
    <SignInLayout>
      <SignInHeader />
      <div className={styles.signInContentWrapper}>
        <div className={styles.textWrapper}>
          {hasGreeting && <Greeting className={styles.greetingWrapper} />}
        </div>
        <ContentBox layout={layout} width="800px">
          <h1>Level TEST</h1>
          {content}
        </ContentBox>
      </div>
    </SignInLayout>
  )
}

export default LevelTestBox
